<section class="content-header" style="padding: 0.5% !important;">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-md-6">
                <ol class="breadcrumb float-sm-left">
                    <li class="breadcrumb-item">
                        <a [routerLink]="['/']"><i class="fas fa-home"></i> &nbsp;Trang chủ</a>
                    </li>
                    <li class="breadcrumb-item active">Thống kê theo QD5363 </li>
                </ol>
            </div>
            <div class="col-md-6">
                <button class="btn btn-info btn-sm" (click)="GetData()" style="float: right; margin-right: 5px;">
                    <i class="fas fa-search"></i> Thống kê dữ liệu </button>
                <button class="btn btn-success btn-sm" (click)="Excel()" style="float: right; margin-right: 5px;">
                    <i class="fas fa-file-excel"></i> Xuất excel 
                </button>
                <button class="btn btn-warning btn-sm"  type="submit" style="float: right;margin-right: 5px; ">
                    <i class="fas fa-info-circle"></i>
                    Hướng dẫn
                </button>
            </div>
        </div>
    </div>
 </section>
 <section class="content cus-body">
    <div class="card">
        <div class="card-body">
            <form class="form-horizontal" [formGroup]="Filter">
                <div class="row" style="padding-left: 10px; padding-right: 10px;">
                    <div class="col-md-3">
                        <label class="col-md-10">Năm học:</label>
                        <select name="" class="form-control" id="Nam_hoc_ft" formControlName="Nam_hoc_ft">
                            <option *ngFor="let i of Nam_hoc_arr" value="{{ i.value }}">{{
                                i.name
                              }}</option>
                        </select>
                    </div>
                    <div class="col-md-3">
                        <label class="col-md-10">Từ khoá:</label>
                        <input class="form-control" formControlName="Tu_khoa_ft" type="number" id="Tu_khoa_ft" />
                    </div>
                    <div class="col-md-3">
                        <label class="col-md-10">Đến khoá:</label>
                        <input class="form-control" formControlName="Den_khoa_ft" type="number" id="Den_khoa_ft" />
                    </div>
                    <div class="col-md-3">
                        <label class="col-md-10">Biểu mẫu:</label>
                        <select name="" class="form-control" id="Bieu_mau_ft" formControlName="Bieu_mau_ft">
                            <option value="0">Biêu số: 02 (Số sinh viên, học sinh đang học tất cả các hệ)</option>
                            <option value="1">Biểu số: 02A (Số sinh viên, học sinh đang học	chia theo tuổi)</option>
                            <option value="2">Biểu số: 02.1 (Sinh viên đang học chia theo ngành đào tạo)</option>
                            <option value="3">Biểu số: 4.1.1-TN (Số sinh viên tốt nghiệp)</option>
                            <option value="4">Biểu số:  4.1.2-TN theo ngành (Số sinh viên tốt nghiệp)</option>
                        </select>
                    </div>
                  
                </div>               
            </form>
        </div>
    </div>
</section> 

<section class="content cus-body">
    <div class="card">
        <div class="card-body">
            <table class="table table-bordered" >
                <tr  *ngFor="let i of dataHeader">
                    <th *ngFor="let value of i.Cells" [attr.colspan]="value.Colspan" [attr.rowspan]="value.Rowspan" style="vertical-align: middle;">
                       {{value.Name}}
                    </th>
                </tr>
                <tbody>
                    <tr *ngFor="let i of dataTable">
                        
                        <td *ngFor="let value of i.Value" [ngStyle]="{'font-weight':value.Bold != true ? '0' :'bold','text-align':value.Format}">
                           {{value.Value}}
                        </td>
                    </tr>
                   
                </tbody>
            </table>
        </div>
    </div>
</section>